export * from './feed-behavior.rules';
export * from './creator-discovery.rules';
export * from './lifecycle-ux.mapping';
export * from './monetization-visibility.rules';
export * from './feed-explanation.model';

/**
 * Product experience definition layer for Loamify.
 * Connects feed, discovery, lifecycle, monetization, and explanation behavior
 * from the user perspective. No runtime logic.
 */
export const LOAMIFY_PRODUCT_BEHAVIOR_SUMMARY = {
  feed: 'FeedBehaviorRules define what appears and why at a product level',
  discovery: 'CreatorDiscoveryRules define how users find and re-find creators',
  lifecycle: 'LifecycleUXMapping defines what each lifecycle state can see and do',
  monetization: 'MonetizationVisibilityRules define commerce visibility behavior',
  explanation: 'FeedExplanationModel defines how every item answers “why is this shown?”',
} as const;
